import { Observable } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { switchMap, catchError } from 'rxjs/operators';
import { GlobalEnvironment, getParams, putParams } from 'Helpers';
import { Item } from 'Models';
import { msalTemp } from 'Contexts/AuthProvider';

export class ItemService {

    static GetItems(): Observable<Item[]> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...getParams, headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };
        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/Items`, params).pipe(
            switchMap(response => {
                if (response.ok) {
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(response.statusText);
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }
    static GetItemsByProjectId(item: Item): Observable<Item[]> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...getParams, headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };
        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/Items/ProjectId/${item}`, params).pipe(
            switchMap(response => {
                if (response.ok) {
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(response.statusText);
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }
    static SaveItem(item: Item): Observable<Item> {
        const accessToken = msalTemp.getActiveAccount()?.idToken
        const params = { ...putParams(JSON.stringify(item)), headers: { Authorization: `Bearer ${accessToken}`, "Content-Type": "application/json" } };
        const data$ = fromFetch(`${GlobalEnvironment.GetUrl_API()}api/Items`, params).pipe(
            switchMap(response => {
                if (response.ok) {
                    return Promise.resolve(response.json());
                } else {
                    return Promise.reject(response.statusText);
                }
            }),
            catchError(err => Promise.reject(err))
        );

        return data$;
    }
}